/** @jsxImportSource @emotion/react */
import { Button } from '@mui/material'
import { useNavigate } from 'react-router-dom'

import { ReactComponent as ArrowIcon } from 'assets/icons/arrow-up.svg'
import { ReactComponent as PlusIcon } from 'assets/icons/plus.svg'

import * as classes from './styles'

type Props = {
  exportDisabled?: boolean
  onAddContent?: () => void
  onExport: () => void
}

export const HeaderButtons = ({ onAddContent, onExport, exportDisabled }: Props) => {
  const navigate = useNavigate()
  return (
    <div css={classes.wrapper}>
      <Button css={classes.backButton} variant="outlined" onClick={() => navigate(-1)} data-testid="back-button">
        <ArrowIcon css={classes.arrowIcon} /> Back to List
      </Button>
      {onAddContent && (
        <Button
          css={classes.addContentButton}
          color="blue"
          variant="outlined"
          data-testid="add-content-button"
          onClick={onAddContent}
        >
          Add Content <PlusIcon css={classes.plusIcon} />
        </Button>
      )}
      <Button
        css={classes.exportButton}
        color="blue"
        variant="contained"
        disabled={exportDisabled}
        data-testid="export-button"
        onClick={onExport}
      >
        Export Responses to Document
      </Button>
    </div>
  )
}
